module.exports = __webpack_public_path__ + "static/media/repair.f014c503.svg";